import { Box, CheckBox, Spacer } from '@jfs/ui-new'
import { FC } from 'react'

const renderList = (checkboxData: any, setCheckboxData: any) => {
  return checkboxData?.map((item: any) => {
    return (
      <Box marginLeft={20} paddingVertical={5}>
        <CheckBox
          checked={item.isChecked}
          onChange={() => {
            const alteredData = checkboxData.map((data: any) => {
              if (data.text.toUpperCase() === item.text.toUpperCase()) {
                data.isChecked = !data.isChecked
              }
              return data
            })
            setCheckboxData(alteredData)
          }}
          iconSize={18}
          color={item.isChecked ? 'PRIMARY' : 'BLACK_LIGHT'}
          textLabel={item.text}
          textColor="DARK_GREY"
          fontWeight={'BOLD'}
          //color="DARK_GREY"
          fontSize={14}
        />
      </Box>
    )
  })
}
const CheckboxList: FC = ({ checkboxData, setCheckboxData, flexDirection = 'row' }: any) => {
  return (
    <Box
      flexDirection={flexDirection}
      borderWidth={1}
      padding={20}
      borderColor="GRAY_BORDER"
      borderRadius={5}
      marginTop={10}>
      <CheckBox
        checked={
          checkboxData.filter((item: any) => {
            return !item.isChecked
          }).length === 0
        }
        onChange={(isChecked: any) => {
          const alteredData = checkboxData.map((data: any) => {
            data.isChecked = isChecked
            return data
          })
          setCheckboxData(alteredData)
        }}
        iconSize={18}
        color={'PRIMARY'}
        textLabel={'Payment Event'}
        textColor="DARK_GREY"
        fontWeight={'BOLD'}
        //color="DARK_GREY"
        fontSize={14}
      />
      <Spacer size={20} />
      {renderList(checkboxData, setCheckboxData)}
    </Box>
  )
}

export { CheckboxList }
